export const back = () => (
  <svg
    width="11"
    height="16"
    viewBox="0 0 11 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7334 0L1.7334 8L9.7334 16"
      stroke="#EDEBF0"
      strokeOpacity="0.98"
      strokeWidth="2"
    />
  </svg>
);
